module.exports = __webpack_public_path__ + "static/sys_ph05-850c2d70ed43f3e237b6df3bd6ff85f2.jpg";